import type { IUsuarioAutenticado } from "../../../modelos/Autenticacion/entidades/IUsuarioAutenticado";
import { EnumPerfiles } from "../../../globales/enums/enumPerfiles";
import { EnumPermisos } from "../../../globales/enums/enumPermisos";

// Roles internos: escogen el proyecto a consultar. Los demás se tratan como cliente (solo sus proyectos).
const ROLES_INTERNOS = [
    EnumPerfiles.Analista,
    EnumPerfiles.CallCenter,
    EnumPerfiles.Comercial,
    EnumPerfiles.Gerente,
    EnumPerfiles.Planeador
];

export const esUsuarioInterno = (usuario: IUsuarioAutenticado | null | undefined) =>
    !!usuario?.Rol?.[0] && ROLES_INTERNOS.includes(usuario.Rol[0].Id);

const tienePermiso = (usuario: IUsuarioAutenticado | null | undefined, permiso: EnumPermisos) =>
    !!usuario?.Permisos?.some(p => p.Codigo === permiso);

// Formatos NBS (visitas de Visita Instalación): sin este permiso esas visitas no se listan.
export const puedeVerFormatosNbs = (usuario: IUsuarioAutenticado | null | undefined) =>
    tienePermiso(usuario, EnumPermisos.PERMISO_GESTION_ARCHIVOS_NBS_VER);

// Mismo permiso que en Tareas (ej. Planeador): el filtro por tipo queda fijo en Visita Instalación.
export const soloVisitaInstalacion = (usuario: IUsuarioAutenticado | null | undefined) =>
    tienePermiso(usuario, EnumPermisos.PERMISO_TAREAS_VER_SOLO_INSTALACION);
